import { NotificationResponse } from '../models';
import { REACT_APP_NOTIFICATION_URL } from 'config';
import { httpClient } from 'features/auth/utils/http';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const useNotificationsQueryKey = 'useNotificationsQueryKey';

export type NotificationsQueryFilters = {
  page: number;
  pageSize: number;
  isRead?: boolean;
};
const fetchNotifications = async (filter: NotificationsQueryFilters) => {
  const params = new URLSearchParams({
    Page: filter.page.toString(),
    PageSize: filter.pageSize.toString()
  });

  if (filter.isRead !== undefined) {
    params.append('IsRead', filter.isRead.toString());
  }

  const result = await httpClient.get<NotificationResponse | undefined | null>(
    `${REACT_APP_NOTIFICATION_URL}/notifications?${params.toString()}`
  );
  return result.data;
};

export const useNotificationsQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  filter: NotificationsQueryFilters,
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchNotifications>>,
      QueryError,
      Awaited<ReturnType<typeof fetchNotifications>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) => useQuery([useNotificationsQueryKey, ...(queryKey ?? [{ ...filter }])], () => fetchNotifications(filter), options);
